import React, {useEffect, useState} from 'react';
import './NotFound.css';
import PocketBase from 'pocketbase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWarning } from '@fortawesome/free-solid-svg-icons'
import {motion} from 'framer-motion'
import InvLogo from '../GlobalComponents/BlurredLogo';



function NotFound() {
    


    return (
        <div className="Not-Found">
            <InvLogo color='white' size={1.5}/>
            <h2 style={{color:'white',paddingTop:'5px',paddingBottom:'5px'}}>Page Not Found</h2>
            <h4 style={{color:'white',paddingTop:'5px',paddingBottom:'5px'}}>You might be a bit lost, no worries the button below will take you right back home.</h4>
            <motion.a href='https://aaatheatingandgas.co.uk' title='Home' whileHover={{scale:1.1}} whileTap={{scale:0.9}} className='Home-Button'>
                <h4 style={{color:'#0e53f0',padding:'10px',paddingLeft:'15px',paddingRight:'15px'}}>Home</h4>
            </motion.a>
        </div>
    );
}

export default NotFound;
